import Logger from '@utils/log'
import useRunsheetDocumentsTableViewModel from './RunsheetDocumentsTableViewModel'
import RunsheetDocumentsRow from './RunsheetDocumentsRow'
import Th from '@/components/shared/TableHeaderManager/Th'
import cn from 'clsx'
import './RunsheetDocumentsTable.css'

// eslint-disable-next-line no-unused-vars
const log = new Logger('RunsheetDocumentsTable')

const RunsheetDocumentsTable = ({
    className,
    runsheetDocs,
    markedDocuments,
    setMarkedDocuments,
    setEditRsDocJoin,
    showHideAdd,
}) => {
    
    const vm = useRunsheetDocumentsTableViewModel(runsheetDocs)
    
    return (
        
        <table ref={vm.tableRef} className={cn('RunsheetDocumentsTable table table-xs table-pin-rows mb-0', className)}>
            <thead>
                <tr>
                    <th>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                className="checkbox checkbox-sm"
                                checked={runsheetDocs.length > 0 && markedDocuments.length === runsheetDocs.length}
                                onChange={e => {
                                    if (e.target.checked)
                                        setMarkedDocuments(runsheetDocs.map(r => r.document.id) || [])
                                    else
                                        setMarkedDocuments([])
                                }} />
                        </div>
                    </th>
                    <th></th>
                    {vm.sortedHeaders.map(([key, sortable, className]) =>
                        <Th
                            className={className}
                            key={key}
                            slug={key}
                            label={vm.getHeaderLabel(key)}
                            sortable={sortable}
                            onHeaderClick={vm.onHeaderClick}
                            orderField={vm.orderField}
                            orderDirection={vm.orderDirection} />)}
                </tr>
            </thead>
            <tbody className="list">
                {vm.sortedDocs.map(it => (
                    <RunsheetDocumentsRow
                        key={it.id}
                        rsDocJoin={it}
                        value={it.value || {}}
                        markedDocuments={markedDocuments}
                        setMarkedDocuments={setMarkedDocuments}
                        setEditRsDocJoin={setEditRsDocJoin}
                        showHideAdd={showHideAdd}
                        updateRunsheetValue={vm.updateRunsheetValue} />
                ))}
            </tbody>
        </table>
        
    )
    
}

export default RunsheetDocumentsTable
